import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      {/* HEADER */}
      <div className="contact-header">
        <span className="contact-eyebrow">GET IN TOUCH</span>
        <h2 className="contact-heading">Book Your Appointment</h2>
        <p className="contact-subtext">
          Ready to give your car the luxury treatment? Contact us today to
          schedule your mobile valeting service.
        </p>
      </div>

      {/* TOP BOXES */}
      <div className="contact-container">
        {/* CONTACT US */}
        <div className="contact-card">
          <h3>Contact Us</h3>
          <div className="card-icon-group">
            <a 
              href="tel:07721482404" 
              className="card-icon"
              aria-label="Call us at 07721 482404"
            >
              <i className="fas fa-phone"></i>
            </a>
            <a
              href="https://wa.me/447721482404"
              target="_blank"
              rel="noopener noreferrer"
              className="card-icon whatsapp"
              aria-label="Message us on WhatsApp"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div>

        {/* EMAIL US */}
        <div className="contact-card">
          <h3>Email Us</h3>
          <div className="card-icon-group">
            <a
              href="mailto:info@luxegoautospa.com"
              className="card-icon"
              aria-label="Send email to info@luxegoautospa.com"
            >
              <i className="fas fa-envelope"></i>
            </a>
          </div>
        </div>

        {/* FOLLOW US */}
        <div className="contact-card">
          <h3>Follow Us</h3>
          <div className="card-icon-group">
            <a
              href="https://instagram.com/luxego_autospa"
              target="_blank"
              rel="noopener noreferrer"
              className="card-icon instagram"
              aria-label="Follow us on Instagram"
            >
              <i className="fab fa-instagram"></i>
            </a>
            <a
              href="https://www.facebook.com/share/1M45hBzHmj/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="card-icon facebook"
              aria-label="Follow us on Facebook"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://youtube.com/@luxegoautospa"
              target="_blank"
              rel="noopener noreferrer"
              className="card-icon youtube"
              aria-label="Subscribe on YouTube"
            >
              <i className="fab fa-youtube"></i>
            </a>
            <a
              href="https://www.tiktok.com/@luxego.auto.spa"
              target="_blank"
              rel="noopener noreferrer"
              className="card-icon tiktok"
              aria-label="Follow us on TikTok"
            >
              <i className="fab fa-tiktok"></i>
            </a>
          </div>
        </div>
      </div>

      {/* SERVICE AREA & AVAILABILITY */}
      <div className="info-card">
        <div className="info-item">
          <div className="info-icon">
            <i className="fas fa-map-marker-alt"></i>
          </div>
          <div>
            <h4>Service Area</h4>
            <p>Chelmsford, Essex & surrounding areas</p>
          </div>
        </div>

        <div className="info-item">
          <div className="info-icon">
            <i className="fas fa-clock"></i>
          </div>
          <div>
            <h4>Availability</h4>
            <p>7 days a week, 8am – 4pm</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;